/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterJ = createReactComponent("outline", "letter-j", "IconLetterJ", [["path", { "d": "M17 4v12a4 4 0 0 1 -4 4h-2a4 4 0 0 1 -4 -4", "key": "svg-0" }]]);

export { IconLetterJ as default };
//# sourceMappingURL=IconLetterJ.mjs.map
